<template>
    <div class="home-block-7">
        <div class="block">
            <div class="cont">
                <div class="item" v-for="(item,index) in list" :key="index">
                    <a :href="item.link" target="_blank">
                    <div class="ico">
                        <img :src="item.icoUrl" title="" alt="">
                        <img :src="item.icoUrl2" title="" alt="" class="bak">
                    </div>
                    <div class="fz24">{{item.department}}</div>
                </a>
                    <div class="p">{{item.description}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EiHomeBlock7",
        data() {
            return {
                list: [
                    {
                        department: '法帖双勾部',
                        description: '部门描述；部门描述；部门描述；部门描述；部门描述；部门描述；部门描述；',
                        link: '',
                        icoUrl: '/upload/homeBlock/7/ico3.png',
                        icoUrl2: '/upload/homeBlock/7/ico3_a.png'
                    },
                    {
                        department: '学术研究部',
                        description: '部门描述；部门描述；部门描述；部门描述；部门描述；部门描述；',
                        link: '',
                        icoUrl: '/upload/homeBlock/7/ico4.png',
                        icoUrl2: '/upload/homeBlock/7/ico4_a.png'
                    },
                    {
                        department: '出版展览部',
                        description: '部门描述；部门描述；部门描述；部门描述；部门描述；部门描述；',
                        link: '',
                        icoUrl: '/upload/homeBlock/7/ico5.png',
                        icoUrl2: '/upload/homeBlock/7/ico5_a.png'
                    },
                    {
                        department: '文旅服务部',
                        description: '部门描述；部门描述；部门描述；部门描述；部门描述；部门描述；',
                        link: '',
                        icoUrl: '/upload/homeBlock/7/ico6.png',
                        icoUrl2: '/upload/homeBlock/7/ico6_a.png'
                    }
                ]
            }
        }
    }
</script>

<style scoped lang="scss">
    .home-block-7{
        margin: 60px auto;
        max-width:1600px;
        min-width: 1600px;
    }
    .cont {
        display: -ms-flexbox;
        display: flex;
    }

    .cont .item {
        -ms-flex: 1;
        flex: 1;
        padding: 40px 30px 30px 30px;
        border-left: 1px solid #eeebea;
        min-height: 225px;
        position: relative;
    }

    .cont .item:before {
        content: "";
        display: block;
        width: 0px;
        background: #94070a;
        top: 3.5%;
        bottom: 15px;
        -webkit-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
        position: absolute;
        left: -3px;
    }

    .cont .item .ico {
        position: relative;
        width: 69px;
        height: 64px;
    }

    .cont .item .ico img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 64px;
        -webkit-transition: all 0.4s ease-in-out;
        transition: all 0.4s ease-in-out;
    }

    .cont .item .ico img.bak {
        width: 0;
    }

    .cont .item .fz24 {
        line-height: 1.4;
        padding: 15px 0;
        -webkit-transition: all 0.4s ease-in-out;
        transition: all 0.4s ease-in-out;
    }

    .cont .item:hover .ico img {
        width: 0;
    }

    .cont .item:hover .ico img.bak {
        width: 100%;
    }

    .cont .item:hover .fz24 {
        color: #8d1c10;
    }

    .cont .item:hover:before {
        width: 5px;
    }
    * img,span,a,div{
      user-select: none;
      -webkit-user-drag:none;
    }
</style>
